module.exports = __webpack_public_path__ + "static/media/boat-img-36.b166c9d1.jpg";